import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
} from '@mui/material';
import {
    useEffect,
    useState
} from 'react';

import { Issue } from '../../API';
import { PermissionResourceType } from '../../models';
import { TemporaryImage } from '../../componentsV2/image/TemporaryImage';
import { UploadStagingImageCarousel } from '../../componentsV2/image/UploadStagingImageCarousel';
import { useUploadImages } from '../../componentsV2/image/carouselComponent/useUploadImage';

type AddIssueImageDialogProps = {
    issue: Issue;
    open: boolean;
    onClose: () => void;
};

export const AddIssueImageDialog = ({
    issue,
    open,
    onClose,
}: AddIssueImageDialogProps) => {
    const [stagedImages, setStagedImages] = useState<Array<TemporaryImage>>([]);
    const { uploadImages } = useUploadImages();

    const handleSubmit = async () => {
        if (stagedImages.length > 0) {
            await Promise.all(
                stagedImages.map(imageDTO =>
                    uploadImages(
                        [imageDTO.file],
                        { shouldResize: true },
                        { id: issue.id, type: PermissionResourceType.ISSUE },
                        issue.propertyId ?? ''
                    )
                )
            );
        }
        onClose();
    };

    useEffect(() => {
        if (open) {
            setStagedImages([]);
        }
    }, [open]);

    return (
        <Dialog
            open={open}
            onClose={(e) => {
                (e as any).stopPropagation();
                onClose();
            }}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle>Add Images to Issue</DialogTitle>
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Box
                            sx={{
                                aspectRatio: "16/9",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"
                            }}
                        >
                            <UploadStagingImageCarousel
                                imageDTOs={stagedImages}
                                setImageDTOs={setStagedImages}
                            />
                        </Box>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={onClose}
                    variant="outlined"
                    color="error"
                >
                    Cancel
                </Button>
                <Button
                    onClick={handleSubmit}
                    variant="contained"
                    disabled={stagedImages.length === 0}
                >
                    Upload Images
                </Button>
            </DialogActions>
        </Dialog>
    );
};